import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { gluteTestimonials } from '../../data/gluteCopy';
export function GluteTestimonials() {
  return <section aria-labelledby="glute-testimonios" className="w-full bg-coal" data-id="element-241" data-mp="11smf475bvy4q">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-242" data-mp="n3q72a39ul44">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-243" data-mp="s2kob7llc1m4">
          Lo que dicen
        </p>
        <h2 id="glute-testimonios" className="mt-5 max-w-2xl text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-244" data-mp="e2jlhmlrmk40">
          Mujeres que ya rompieron el bloqueo
        </h2>

        <div className="mt-10 grid gap-4 sm:mt-14 sm:gap-5 lg:grid-cols-3" data-id="element-245" data-mp="94i7vh73zczx">
          {gluteTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-xl border border-coal-line bg-coal-card p-6" data-id="element-246" data-mp="1ykpyz4lpixxm">
              <QuoteIcon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-247" data-mp="vjqy4c7us2jg" />
              <blockquote className="mt-4 text-[0.95rem] leading-relaxed text-white/70" data-id="element-248" data-mp="vhmmf83ppz8m">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-249" data-mp="14cau14wrft0l">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-ember/15 text-[0.8rem] font-bold text-ember" aria-hidden="true" data-id="element-250" data-mp="10apk9sfivuum">
                  {item.name.charAt(0)}
                </span>
                <span data-id="element-251" data-mp="7o4uuxilxstp">
                  <span className="block text-[0.9rem] font-semibold text-white" data-id="element-252" data-mp="llb6m84wyr9f">{item.name}</span>
                  <span className="block text-[0.78rem] text-white/40" data-id="element-253" data-mp="gmqaokwp2tqs">{item.detail}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-[0.75rem] leading-relaxed text-white/30" data-id="element-254" data-mp="1s1n9unmlezbv">
          Testimonios de lectoras del programa. Los resultados varían según el punto de partida y la
          constancia de cada persona.
        </p>
      </div>
    </section>;
}